interface HoursMinutes {
  hours: number | null
  minutes: number | null
}

/**
 * toHoursAndMinutes - A function to get hours and minutes from total minutes.
 * type the function to return an object with hours and minutes
 * @param totalMinutes
 * @return {Object} An object with hours and minutes
 */
export const toHoursAndMinutes = (
  totalMinutes: number | null
): HoursMinutes => {
  if (!totalMinutes || totalMinutes <= 0) {
    return { hours: null, minutes: null }
  }

  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return { hours, minutes }
}

/**
 *  Generate a date string for a given number of days from today
 * @param daysFromToday  The number of days from today
 * @returns  A date string
 */
export const generateDate = (daysFromToday: number) => {
  const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000
  const date = new Date(Date.now() + daysFromToday * DAY_IN_MILLISECONDS)
  date.setHours(0, 0, 0, 0)
  return date.toISOString()
}
